import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'], // Fixed typo: styleUrl -> styleUrls
})
export class LoaderComponent {
  @Input() isContentStart: boolean = false; // Default value is false
}
